export function getPath(): string {
  return window.location.host.includes(':3000')
    ? 'http://localhost:8888/cms/'
    // ? 'https://musicmonks.gk-lab.de/cms/'
      //"https://preview.id-ms.de/cms/"
    :  '/cms/';
}
